/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import wysiwyg from './vueWysiwyg'
import DatePicker from 'vue2-datepicker'
import TreeView from 'vue-json-tree-view'

import router from './router';
import store from './store';
import i18n from './i18n'
import App from './layouts/App.vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('help-modal', require('./components/HelpModal.vue').default);
Vue.component('NavBar', require('./layouts/NavBar.vue').default);
Vue.component('Alert', require('./components/Alert.vue').default);
Vue.component('Confirm', require('./components/Confirm.vue').default);
Vue.component('SidebarLeft', require('./components/SidebarLeft.vue').default);
Vue.component('SidebarRight', require('./components/SidebarRight.vue').default);
Vue.component('UserMessage', require('./components/UserMessage.vue').default);

window.axiosInstance.interceptors.response.use((response) => {
  if (response.status === 302 && response.data.redirect_name && app.$route.name !== response.data.redirect_name) {
      app.$router.push({name: response.data.redirect_name, replace: true}).catch()
      return Promise.reject(response.data.message)
  }
  return response
}, error => {
  if (error && error.response && error.response.status === 401) {
    app.$store.commit('user/userLogout')
    if(app.$route.name !== 'login') {
      app.$router.push('/login').catch()
      return true
    }
  }

  return Promise.reject(error)
})

Vue.prototype.$axios = window.axiosInstance

window.wysiwygconf = {
  // { [module]: boolean (set true to hide) }
  // hideModules: {'bold': true},
  // you can override icons too, if desired
  // just keep in mind that you may need custom styles in your application to get everything to align
  // iconOverrides: {'bold': "<i class='your-custom-icon'></i>"},
  // if the image option is not set, images are inserted as base64
  image: {
    uploadURL: base_url + '/api/v1/messages/upload',
    dropzoneOptions: {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') || '' }
    }
  },
  // limit content height if you wish. If not set, editor size will grow with content.
  // maxHeight: '500px',
  // set to 'true' this will insert plain text without styling when you paste something into the editor.
  // forcePlainTextOnPaste: true,
  // specify editor locale, if you don't specify this, the editor will default to english.
  // locale: 'en'
}

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(wysiwyg, window.wysiwygconf)
Vue.use(DatePicker)
Vue.use(TreeView)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  data () {
    return {
      isMobileApp: false,
      isMobileBrowser: false,
      appname,
      appversion,
      prevRoute: null,
      messagesconf: {
        messageType: [
          { value: 'normal', text: this.$t('messages.normal') },
          { value: 'burtiera', text: this.$t('messages.burtiera') },
          { value: 'imagine', text: this.$t('messages.imagine') },
        ],
        channels: [
          { value: 'clienti-activi-promo', text: this.$t('messages.clienti-activi-promo') },
          { value: 'eoriginal-cl-dep', text: this.$t('messages.eoriginal-cl-dep') },
          { value: 'eoriginal-clienti', text: this.$t('messages.eoriginal-clienti') },
          { value: 'eoriginal-clienti-funzone', text: this.$t('messages.eoriginal-clienti-funzone') },
          { value: 'eoriginal-clienti-no-funzone', text: this.$t('messages.eoriginal-clienti-no-funzone') },
          { value: 'eoriginal-erp', text: this.$t('messages.eoriginal-erp') },
          { value: 'eoriginal', text: this.$t('messages.eoriginal') }
        ]
      }
    }
  },
  methods: {
    colorFromString (string) {
      if (string && string.length > 0) {
        var hash = 0
        var colour = '#'

        for (var i = 0; i < string.length; i++) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash)
        }

        for (var i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 0xFF
          colour += ('00' + value.toString(16)).substr(-2)
        }

        return colour
      }

      return '#6c757d'
    },
    linkGen (pageNum) {
      return {
        path: this.$route.path,
        query: { ...this.$route.query, page: pageNum }
      }
    },

    calcNrPages (total, perPage) {
      if (total && perPage) {
        return Math.ceil(total / perPage)
      }

      return null
    },

    goTo (routeName, params, query = null) {
      if (query) {
        return { name: routeName, params, query }
      }

      return { name: routeName, params }
    },

    checkOnlineStatus (user_id) {
      if (user_id && !this.$store.state.users.onlineUsers.find(ou => ou._id === user_id)) {
        return false
      }

      return true
    },

    setLanguage (lang = 'ro') {
      this.$i18n.locale = lang
      this.$axios.defaults.headers.common['Content-Language'] = lang
      localStorage.setItem('language', lang)
      this.$store.commit('common/setLang', lang)
      window.location.reload(true)
    },

    countFilters (filters) {
      let count = 0
      for (var key in filters) {
        if (filters[key] !== '') {
          count++
        }
      }

      return count
    },

    breadcrumb (page) {
      if (page === this.$t('home')) {
        return [
          {
            text: this.$t('home'),
            active: true
          }
        ]
      }

      return [
        {
          text: (this.$store.state.user.user && this.$store.state.user.user.userMenu && this.$store.state.user.user.userMenu[0] && this.$store.state.user.user.userMenu[0].title) ? this.$store.state.user.user.userMenu[0].title : this.$t('home'),
          to: (this.$store.state.user.user && this.$store.state.user.user.userMenu && this.$store.state.user.user.userMenu[0] && this.$store.state.user.user.userMenu[0].href) ? this.$store.state.user.user.userMenu[0].href : '/'
        },
        {
          text: page || this.$t('unknownpage'),
          active: true
        }
      ]
    },
    exitApp () {
      navigator.app.exitApp()
    }
  },
  watch: {
    $route (to, from) {
      this.prevRoute = from
    }
  },
  beforeCreate() {
    this.$i18n.locale = localStorage.getItem('language') || 'ro'
  },
  mounted () {
  },
  render: h => h(App)
})

import * as Sentry from "@sentry/vue";

if(process.env.MIX_APP_ENV !== 'local') {
  Sentry.init({
    Vue,
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE),
    release: 'admin-eoriginal@' + appversion
  })
}